import React from 'react';

var _path;

var SvgActivitiesMajor = function SvgActivitiesMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.111.221a3.04 3.04 0 0 1 1.002.66h-.003a2.992 2.992 0 0 1 .89 2.18c-.224 14.324-4.22 16.692-16.931 16.94h-.06c-.797 0-1.548-.31-2.12-.88a2.989 2.989 0 0 1-.889-2.184c.226-14.322 4.22-16.689 16.932-16.937.404-.005.805.07 1.179.221zm-10.232 7.659a1 1 0 0 1 1.414 0l.708.707 1.414-1.414-.707-.707a1 1 0 0 1 1.414-1.414l.707.707 1.464-1.465a1 1 0 1 1 1.415 1.414l-1.465 1.465.707.707a1 1 0 0 1-1.414 1.414l-.707-.707-1.414 1.413.707.707a1 1 0 1 1-1.414 1.415l-.708-.707-1.415 1.414.707.707a1 1 0 1 1-1.412 1.414l-.707-.707-1.464 1.464a1 1 0 0 1-1.415-1.414l1.465-1.464-.707-.707a1 1 0 1 1 1.414-1.415l.707.707 1.413-1.414-.707-.707a1 1 0 0 1 0-1.414z"
  })));
};

export { SvgActivitiesMajor as S };
